import Service from "../../services";

const Auth = {
    namespaced: true,
    state: {
        user: null,
        role: null,
        accessToken: null,
        refreshToken: null,
        workState: null,
        permission: null
    },
    mutations: {
        SET_ACCESS_TOKEN: (state, token) => {
            state.accessToken = token
        },
        SET_REFRESH_TOKEN: (state, token) => {
            state.refreshToken = token
        },
        SET_USER: (state, user) => {
            state.user = user
        },
        SET_ROLE: (state, role) => {
            state.role = role
        },
        SET_WORK_STATE: (state, data) => {
            state.workState = data
        },
        SET_PERMISSION: (state, data) => {
            state.permission = data
        }
    },
    actions: {
        login({
            commit
        }, data) {
            return Service.Auth.login(data)
                .then(res => {
                    if (res.status == 'ok') {
                        commit('SET_ACCESS_TOKEN', res.token)
                        return res.data
                    }
                    return Promise.reject('Invalid username/password')
                })
                .catch(err => {
                    console.log(err)
                    /*
                    //console.log(data.data.access_token)
                    //commit('SET_REFRESH_TOKEN', data.data.refresh_token)
                    return data
                    */
                })
        },
        setUser() {
            return Service.Auth.me()
                .then(data => {
                    /*
                    let role_id = data.user.role_id
                    return Service.auth.getUserRole(role_id).then(role => {
                        commit('SET_ROLE', role.data)
                        commit('SET_USER', data.user)
                    })
                    */
                    return data.user
                })
                .catch(err => Promise.reject(err))
        },
        setProfile() {
            return Service.User.me()
                .then(data => {
                    /*
                    let role_id = data.user.role_id
                    return Service.auth.getUserRole(role_id).then(role => {
                        commit('SET_ROLE', role.data)
                        commit('SET_USER', data.user)
                    })
                    */
                    return data.user
                })
                .catch(err => Promise.reject(err))
        },
        setWorkState({
            commit
        }, data) {
            commit('SET_WORK_STATE', data)
        },
        getPermission({
            state
        }) {
            return state.permission
        },
        logout({
            commit
        }) {
            commit('SET_USER', null)
            commit('SET_ACCESS_TOKEN', null)
            commit('SET_REFRESH_TOKEN', null)
            commit('SET_PERMISSION', null)
        }
    },
}

export default Auth